import { createRouter, createWebHistory } from 'vue-router';
import home_view from '../views/home_view.vue';
import nous_contacter from '../views/nous_contacter.vue';
import apaym_pro from '../views/apaym_pro.vue';
import nos_services from '../views/nos_services.vue';
import mentions_legales from '../views/mentions_legales.vue';
import qui_sommes_nous from '../views/qui_sommes_nous.vue';
import faq from '../views/faq.vue';
import nos_produits from '../views/nos_produits.vue';
import lien_paiment from '../views/lien_paiement.vue';
import tpe from '../views/tpe.vue';
import tutos from '../views/tutos.vue';
import nos_cartes from '../views/nos_cartes.vue';
import tarifs from '../views/tarifs.vue';
import classic from '../views/classic.vue';
import platinum_noir from '../views/platinum-noir';
import carte_virtuelle_uba from '../views/carte-virtuelle-uba.vue';
import virtuelle_ecobank from '../views/carte-virtuelle-ecobank.vue';
import carte_apaym from '../views/carte-apaym-pro.vue';
import privileges from '../views/privileges.vue';
import privileges_details from '../views/privileges_details.vue';
import points_de_vente from '../views/points-vente.vue';
import agences from '../views/agences.vue';
import agence from '../views/agence.vue';
import parle_de_nous from '../views/parle-de-nous.vue';
import app from '../views/app.vue';
import NotFound from '../views/NotFound.vue';


const routes = [    

    {
        //path: '/home',
        path: '/',
        name: 'home_view',
        component: home_view,
        meta: {
            title: 'APaym - Everyday, Everywhere',
            metaTags: [
                {
                    name: 'description',
                    content: 'La super App APaym'
                },
                {
                    property: 'og:description',
                    content: 'La super App APaym'
                }
            ]
        },
    },

    {
        path: '/nous-contacter',
        component: nous_contacter,
        meta: {
            title: 'APaym - Nous Contacter',
            metaTags: [
                {
                    name: 'description',
                    content: 'Nos équipes commerciales et techniques sont à votre écoute pour répondre rapidement à tous vos besoins'
                },
                {
                    property: 'og:description',
                    content: 'Nos équipes commerciales et techniques sont à votre écoute pour répondre rapidement à tous vos besoins'
                }
            ]
        },
        
    },

    {
        path: '/apaym-pro',
        
        component: apaym_pro,
        meta: {
            title: 'APaym -  APAYM PRO, encaisse comme tu veux',
            metaTags: [
                {
                    name: 'description',
                    content: 'APaym PRO est une solution de paiement spécialement conçue pour ACCEPTER, faciliter et accélérer le paiement digital des commerces, petites et moyennes entreprises.'
                },
                {
                    property: 'og:description',
                    content: 'APaym PRO est une solution de paiement spécialement conçue pour ACCEPTER, faciliter et accélérer le paiement digital des commerces, petites et moyennes entreprises.'
                }
            ]
        },
        
    },

    {
        path: '/services',
        component: nos_services,
        meta: {
            title: 'APaym - Nos services',
            metaTags: [
                {
                    name: 'description',
                    content: 'Nos équipes commerciales et techniques sont à votre écoute pour répondre rapidement à tous vos besoins'
                },
                {
                    property: 'og:description',
                    content: 'Nos équipes commerciales et techniques sont à votre écoute pour répondre rapidement à tous vos besoins'
                }
            ]
        },
        
    },

    {
        path: '/nos-cartes',
        name: 'nos_cartes',
        component: nos_cartes,
        meta: {
            title: 'APaym - Nos cartes VISA',
            metaTags: [
                {
                    name: 'description',
                    content: 'Nos équipes commerciales et techniques sont à votre écoute pour répondre rapidement à tous vos besoins'
                },
                {
                    property: 'og:description',
                    content: 'Nos équipes commerciales et techniques sont à votre écoute pour répondre rapidement à tous vos besoins'
                }
            ]
        },
        
    },

    {
        path: '/mentions-legales',
        name: 'mentions_legales',
        component: mentions_legales,
        meta: {
            title: 'APaym - Mention Légales & Conditions d’utilisation du site',
            metaTags: [
                {
                    name: 'description',
                    content: 'Nos équipes commerciales et techniques sont à votre écoute pour répondre rapidement à tous vos besoins'
                },
                {
                    property: 'og:description',
                    content: 'Nos équipes commerciales et techniques sont à votre écoute pour répondre rapidement à tous vos besoins'
                }
            ]
        },
        
    },

    {
        path: '/qui-sommes-nous',
        name: 'qui_sommes_nous',
        component: qui_sommes_nous,
        meta: {
            title: 'APaym - Qui sommes nous',
            metaTags: [
                {
                    name: 'description',
                    content: 'Nos équipes commerciales et techniques sont à votre écoute pour répondre rapidement à tous vos besoins'
                },
                {
                    property: 'og:description',
                    content: 'Nos équipes commerciales et techniques sont à votre écoute pour répondre rapidement à tous vos besoins'
                }
            ]
        },
        
    },

    {
        path: '/faq',
        name: 'faq',
        component: faq,
        meta: {
            title: 'APaym - Questions générales',
            metaTags: [
                {
                    name: 'description',
                    content: 'Nos équipes commerciales et techniques sont à votre écoute pour répondre rapidement à tous vos besoins'
                },
                {
                    property: 'og:description',
                    content: 'Nos équipes commerciales et techniques sont à votre écoute pour répondre rapidement à tous vos besoins'
                }
            ]
        },
        
    },

    {
        path: '/nos-produits',
        name: 'nos_produits',
        component: nos_produits,
        meta: {
            title: 'APaym - Nos produits',
            metaTags: [
                {
                    name: 'description',
                    content: 'Nos équipes commerciales et techniques sont à votre écoute pour répondre rapidement à tous vos besoins'
                },
                {
                    property: 'og:description',
                    content: 'Nos équipes commerciales et techniques sont à votre écoute pour répondre rapidement à tous vos besoins'
                }
            ]
        },
        
    },

    {
        path: '/lien-paiement',
        name: 'lien_paiment',
        component: lien_paiment,
        meta: {
            title: 'APaym pro - Lien de paiement',
            metaTags: [
                {
                    name: 'description',
                    content: 'Nos équipes commerciales et techniques sont à votre écoute pour répondre rapidement à tous vos besoins'
                },
                {
                    property: 'og:description',
                    content: 'Nos équipes commerciales et techniques sont à votre écoute pour répondre rapidement à tous vos besoins'
                }
            ]
        },
        
    },

    {
        path: '/tpe',
        name: 'tpe',
        component: tpe,
        meta: {
            title: 'APaym pro - TPE virtuelle',
            metaTags: [
                {
                    name: 'description',
                    content: 'Nos équipes commerciales et techniques sont à votre écoute pour répondre rapidement à tous vos besoins'
                },
                {
                    property: 'og:description',
                    content: 'Nos équipes commerciales et techniques sont à votre écoute pour répondre rapidement à tous vos besoins'
                }
            ]
        },
        
    },

    {
        path: '/tutos',
        name: 'tutos',
        component: tutos,
        meta: {
            title: 'APaym pro - Nos vidéos tutos ',
            metaTags: [
                {
                    name: 'description',
                    content: 'Nos équipes commerciales et techniques sont à votre écoute pour répondre rapidement à tous vos besoins'
                },
                {
                    property: 'og:description',
                    content: 'Nos équipes commerciales et techniques sont à votre écoute pour répondre rapidement à tous vos besoins'
                }
            ]
        },
        
    },

    {
        path: '/nos-cartes',
        name: 'nos_cartes',
        component: nos_cartes,
        meta: {
            title: 'APaym  - Nos cartes VISA Prépayée',
            metaTags: [
                {
                    name: 'description',
                    content: 'Nos cartes sont des cartes Visa prépayée internationale hautement sécurisée qui vous accompagne partout dans vos achats en ligne ainsi que dans toutes les surfaces'
                },
                {
                    property: 'og:description',
                    content: 'Nos cartes sont des cartes Visa prépayée internationale hautement sécurisée qui vous accompagne partout dans vos achats en ligne ainsi que dans toutes les surfaces'
                }
            ]
        },
        
    },

    {
        path: '/tarifs',
        name: 'tarifs',
        component: tarifs,
        meta: {
            title: 'APaym  - Nos tarifs',
            metaTags: [
                {
                    name: 'description',
                    content: 'Nos tarifs sont compétitifs et adaptés à tous les besoins. N\'hésitez pas à nous contacter pour en savoir plus sur nos tarifs et pour obtenir plus d\'informations'
                },
                {
                    property: 'og:description',
                    content: 'Nos tarifs sont compétitifs et adaptés à tous les besoins. N\'hésitez pas à nous contacter pour en savoir plus sur nos tarifs et pour obtenir plus d\'informations'
                }
            ]
        },
        
    },

    {
        path: '/carte-classic',
        name: 'classic',
        component: classic,
        meta: {
            title: 'APaym  - Carte Classic',
            metaTags: [
                {
                    name: 'description',
                    content: 'La carte classique Abidjan.net est une carte Visa prépayée internationale hautement sécurisée'
                },
                {
                    property: 'og:description',
                    content: 'La carte classique Abidjan.net est une carte Visa prépayée internationale hautement sécurisée'
                }
            ]
        },
        
    },

    {
        path: '/platinum-noir',
        name: 'platinum-noir',
        component: platinum_noir,
        meta: {
            title: 'APaym  - Carte platinum noir',
            metaTags: [
                {
                    name: 'description',
                    content: 'La carte classique Abidjan.net est une carte Visa prépayée internationale hautement sécurisée'
                },
                {
                    property: 'og:description',
                    content: 'La carte classique Abidjan.net est une carte Visa prépayée internationale hautement sécurisée'
                }
            ]
        },
        
    },

    {
        path: '/carte-virtuelle-uba',
        name: 'carte-virtuelle-uba',
        component: carte_virtuelle_uba,
        meta: {
            title: 'APaym  - Carte virtuelle APAYM',
            metaTags: [
                {
                    name: 'description',
                    content: 'La carte classique Abidjan.net est une carte Visa prépayée internationale hautement sécurisée'
                },
                {
                    property: 'og:description',
                    content: 'La carte classique Abidjan.net est une carte Visa prépayée internationale hautement sécurisée'
                }
            ]
        },
        
    },
    
    {
        path: '/carte-virtuelle-ecobank',
        name: 'carte-virtuelle-ecobank',
        component: virtuelle_ecobank,
        meta: {
            title: 'APaym  - Carte virtuelle Ecobank',
            metaTags: [
                {
                    name: 'description',
                    content: 'La carte classique Abidjan.net est une carte Visa prépayée internationale hautement sécurisée'
                },
                {
                    property: 'og:description',
                    content: 'La carte classique Abidjan.net est une carte Visa prépayée internationale hautement sécurisée'
                }
            ]
        },
        
    },

    {
        path: '/carte-apaym-pro',
        name: 'carte-apaym-pro',
        component: carte_apaym,
        meta: {
            title: 'APaym  - Carte Visa APAYM Pro',
            metaTags: [
                {
                    name: 'description',
                    content: 'En partenariat avec ECOBANK, la carte APAYM PRO est une carte dédiée aux marchands et elle peut-être rattachée à un compte APAYM PRO afin de permettre a tous marchands de recevoir de façon instantanée tous les paiements de ses clients vivant en Côte d’Ivoire et à l’etranger.'
                },
                {
                    property: 'og:description',
                    content: 'En partenariat avec ECOBANK, la carte APAYM PRO est une carte dédiée aux marchands et elle peut-être rattachée à un compte APAYM PRO afin de permettre a tous marchands de recevoir de façon instantanée tous les paiements de ses clients vivant en Côte d’Ivoire et à l’etranger.'
                }
            ]
        },
        
    },    

    {
        path: '/privileges',
        name: 'privileges',
        component: privileges,
        // children: [
        //     { path: ':slug', name: 'privileges_details', component: privileges_details }
        // ],
        meta: {
            title: 'APaym  - profitez d\'une réduction exclusive de 25% chez nos partenaires sélectionnés',
            metaTags: [
                {
                    name: 'description',
                    content: 'profitez d\'une réduction exclusive de 25% chez nos partenaires sélectionnés'
                },
                {
                    property: 'og:description',
                    content: 'profitez d\'une réduction exclusive de 25% chez nos partenaires sélectionnés'
                }
            ]
        },
        
    },    
    
    {
        path: '/partenaire/:id',
        name: 'partenaire',
        component: privileges_details,
        
        props: true,
        meta: {
            title: 'APaym  - profitez d\'une réduction exclusive de 25% chez nos partenaires sélectionnés',
            metaTags: [
                {
                    name: 'description',
                    content: 'profitez d\'une réduction exclusive de 25% chez nos partenaires sélectionnés'
                },
                {
                    property: 'og:description',
                    content: 'profitez d\'une réduction exclusive de 25% chez nos partenaires sélectionnés'
                }
            ]
        },

        
    }, 

    {
        path: '/points-de-vente',
        name: 'points-de-vente',
        component: points_de_vente,
        
        props: true,
        meta: {
            title: 'APaym  - Vos agences Weblogy, plus proches de vous !',
            metaTags: [
                {
                    name: 'description',
                    content: 'Vos agences Weblogy, plus proches de vous !'
                },
                {
                    property: 'og:description',
                    content: 'Vos agences Weblogy, plus proches de vous !'
                }
            ]
        },

        
    }, 

    {
        path: '/agences/:id',
        name: 'agences',
        component: agences,
        
        props: true,
        meta: {
            title: 'APaym  - profitez d\'une réduction exclusive de 25% chez nos partenaires sélectionnés',
            metaTags: [
                {
                    name: 'description',
                    content: 'profitez d\'une réduction exclusive de 25% chez nos partenaires sélectionnés'
                },
                {
                    property: 'og:description',
                    content: 'profitez d\'une réduction exclusive de 25% chez nos partenaires sélectionnés'
                }
            ]
        },

        
    }, 

    {
        path: '/agence/:id',
        name: 'agence',
        component: agence,
        
        props: true,
        meta: {
            title: 'APaym  - profitez d\'une réduction exclusive de 25% chez nos partenaires sélectionnés',
            metaTags: [
                {
                    name: 'description',
                    content: 'profitez d\'une réduction exclusive de 25% chez nos partenaires sélectionnés'
                },
                {
                    property: 'og:description',
                    content: 'profitez d\'une réduction exclusive de 25% chez nos partenaires sélectionnés'
                }
            ]
        },

        
    }, 

    {
        path: '/on-parle-de-nous',
        name: 'on-parle-de-nous',
        component: parle_de_nous,
        
        props: true,
        meta: {
            title: 'APaym  - Vos agences Weblogy, plus proches de vous !',
            metaTags: [
                {
                    name: 'description',
                    content: 'Vos agences Weblogy, plus proches de vous !'
                },
                {
                    property: 'og:description',
                    content: 'Vos agences Weblogy, plus proches de vous !'
                }
            ]
        },

        
    },
    
    {
        path: '/app',
        name: 'app',
        component: app,
        
        props: true,
        meta: {
            title: 'APaym  - Paie, Transfert et Recharge avec toutes les cartes Visa',
            metaTags: [
                {
                    name: 'description',
                    content: 'APAYM : Paie, Transfert et Recharge avec toutes les cartes Visa'
                },
                {
                    property: 'og:description',
                    content: 'APAYM : Paie, Transfert et Recharge avec toutes les cartes Visa'
                }
            ]
        },

        
    },

   
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: NotFound,
        meta: {
            title: 'APaym  - Erreur 404',
    
        },
      },   
    
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,

    scrollBehavior(to, from, SavedPosition){
        return SavedPosition ||  { top:0 }
    }
})

//dynamic set of page title
router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title}`;
    document.metaTags = `${to.meta.metaTags}`;
    next();
});

export default router